"use strict";

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
      label: 0,
      sent: function () {
        if (t[0] & 1) throw t[1];
        return t[1];
      },
      trys: [],
      ops: []
    },
    f,
    y,
    t,
    g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;
  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");
    while (_) try {
      if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
      if (y = 0, t) op = [op[0] & 2, t.value];
      switch (op[0]) {
        case 0:
        case 1:
          t = op;
          break;
        case 4:
          _.label++;
          return {
            value: op[1],
            done: false
          };
        case 5:
          _.label++;
          y = op[1];
          op = [0];
          continue;
        case 7:
          op = _.ops.pop();
          _.trys.pop();
          continue;
        default:
          if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
            _ = 0;
            continue;
          }
          if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
            _.label = op[1];
            break;
          }
          if (op[0] === 6 && _.label < t[1]) {
            _.label = t[1];
            t = op;
            break;
          }
          if (t && _.label < t[2]) {
            _.label = t[2];
            _.ops.push(op);
            break;
          }
          if (t[2]) _.ops.pop();
          _.trys.pop();
          continue;
      }
      op = body.call(thisArg, _);
    } catch (e) {
      op = [6, e];
      y = 0;
    } finally {
      f = t = 0;
    }
    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var axios_1 = require("axios");
var helperFunctions_1 = require("./helperFunctions");
// Initiate authentication using Facebook
exports.login = function (sourceApp, baseurl, realm, tree, domain, name) {
  return __awaiter(void 0, void 0, void 0, function () {
    var sourceAppCallBack, redirectObject, redirectFacebookUrl, authId;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          return [4 /*yield*/, helperFunctions_1.getAndSubmitSourceAppCallback(sourceApp, baseurl, realm, tree, name)];
        case 1:
          sourceAppCallBack = _a.sent();
          return [4 /*yield*/, exports.getRedirectObject(sourceAppCallBack.response, baseurl, realm, tree, name)];
        case 2:
          redirectObject = _a.sent();
          redirectFacebookUrl = helperFunctions_1.processRedirectObject(redirectObject);
          authId = helperFunctions_1.getAuthId(redirectObject);
          sessionStorage.setItem("AP_authId", authId);
          // setCookies("authId", authId, "/", domain);
          //Redirect user to Facebook sign in page
          helperFunctions_1.redirect(redirectFacebookUrl);
          return [2 /*return*/];
      }
    });
  });
};
//Complete Facebook authentication after returning from Facebook sign in
exports.complete = function (baseurl, realm, tree, domain, name) {
  return __awaiter(void 0, void 0, void 0, function () {
    var urlParams, url, splitParams, authId, headers, body;
    return __generator(this, function (_a) {
      urlParams = helperFunctions_1.getURLParams();
      url = baseurl + "/" + name + "/json" + realm + "/authenticate" + urlParams;
      splitParams = helperFunctions_1.parseURL(window.location.search);
      authId = sessionStorage.AP_authId;
      sessionStorage.removeItem("AP_authId");
      headers = {
        "Accept-API-Version": "resource=2.0",
        "Content-Type": "application/json"
      };
      body = {
        "realm": realm,
        "authIndexType": "service",
        "authIndexValue": tree,
        "authId": authId,
        "state": splitParams["state"],
        "code": splitParams["code"],
        "scope": splitParams["scope"],
        "authuser": splitParams["authuser"],
        "prompt": splitParams["prompt"],
        "session_state": splitParams["session_state"]
      };
      return [2 /*return*/, exports.finishFacebookAuth(url, headers, body)];
    });
  });
};
// Complete Facebook registration after returning from Facebook sign in in which no account was found
// In this scenario, the user allowed Facebook to share their email address, so only mobileNumber is needed from the user
exports.finishFacebookRegistration = function (callback, email, mobileNumber, firstName, lastName, sourceApp, baseurl, realm, name) {
  return __awaiter(void 0, void 0, void 0, function () {
    var url, headers, i, body;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          url = baseurl + "/" + name + "/json" + realm + "/authenticate";
          headers = {
            "Accept-API-Version": "resource=2.1",
            "Content-Type": "application/json"
          };
          try {
            for (i in callback.callbacks) {
              if (callback.callbacks[i].output[0].value === "Mobile Number") {
                callback.callbacks[i].input[0].value = mobileNumber;
              } else if (callback.callbacks[i].output[0].value === "Email Address") {
                callback.callbacks[i].input[0].value = email;
              } else if (callback.callbacks[i].output[0].value === "First Name") {
                callback.callbacks[i].input[0].value = firstName;
              } else if (callback.callbacks[i].output[0].value === "Last Name") {
                callback.callbacks[i].input[0].value = lastName;
              } else if (callback.callbacks[i].output[0].value === "sourceApp") {
                callback.callbacks[i].input[0].value = sourceApp;
              }
            }
          } catch (err) {
            return [2 /*return*/, {
              error: err
            }];
          }
          body = callback;
          return [4 /*yield*/, axios_1.default({
            data: body,
            method: 'post',
            headers: headers,
            url: url
          }).then(function (resp) {
            return {
              response: resp.data
            };
          }).catch(function (err) {
            return {
              error: err
            };
          })];
        case 1:
          return [2 /*return*/, _a.sent()];
      }
    });
  });
};
// Complete Facebook registration after returning from Facebook sign in in which no account was found
// In this scenario, the user DID NOT allow Facebook to share their email address, so both email and mobileNumber are needed from the user
exports.finishFacebookRegistrationMissingEmail = function (callback, email, mobileNumber, sourceApp, baseurl, realm, name) {
  return __awaiter(void 0, void 0, void 0, function () {
    var url, headers, body;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          url = baseurl + "/" + name + "/json" + realm + "/authenticate";
          headers = {
            "Accept-API-Version": "resource=2.1",
            "Content-Type": "application/json"
          };
          callback.callbacks[0].input[0].value = email;
          callback.callbacks[1].input[0].value = mobileNumber;
          callback.callbacks[2].input[0].value = sourceApp;
          body = callback;
          return [4 /*yield*/, axios_1.default({
            data: body,
            method: 'post',
            headers: headers,
            url: url
          }).then(function (resp) {
            return {
              response: resp.data
            };
          }).catch(function (err) {
            return {
              error: err
            };
          })];
        case 1:
          return [2 /*return*/, _a.sent()];
      }
    });
  });
};
//Call API to complete Facebook authentication after returning from Facebook sign in
exports.finishFacebookAuth = function (url, headers, body) {
  return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          return [4 /*yield*/, axios_1.default({
            withCredentials: true,
            data: body,
            headers: headers,
            method: "post",
            url: url
          }).then(function (response) {
            return {
              response: response.data,
              status: response.status
            };
          }).catch(function (err) {
            return {
              response: err.response.data,
              status: err.response.status
            };
          })];
        case 1:
          return [2 /*return*/, _a.sent()];
      }
    });
  });
};
//Call API for Facebook JSON response
exports.getRedirectObject = function (data, baseurl, realm, tree, name) {
  return __awaiter(void 0, void 0, void 0, function () {
    var url, headers, params;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          url = baseurl + "/" + name + "/json" + realm + "/authenticate";
          headers = {
            "Accept-API-Version": "resource=2.0",
            "Content-Type": "application/json"
          };
          params = {
            "authIndexType": "service",
            "authIndexValue": tree
          };
          return [4 /*yield*/, axios_1.default({
            data: data,
            headers: headers,
            method: "post",
            params: params,
            url: url
          }).then(function (response) {
            return {
              response: response.data,
              status: response.status
            };
          }).catch(function (err) {
            return {
              response: err.response.data,
              status: err.response.status
            };
          })];
        case 1:
          return [2 /*return*/, _a.sent()];
      }
    });
  });
};